import { TOGGLE_SELECT_ALL_DEVICES } from '../constants/actionTypes';
import { DevicesActionTypes } from '../device/devicesActions';

export const toggleSelectAllDevices = (isChecked: boolean): DevicesActionTypes => ({
  type: TOGGLE_SELECT_ALL_DEVICES,
  payload: isChecked,
});
